import React, {Component} from 'react';
import './index.less';
import { Toast } from 'antd-mobile';
export default class Shunt extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
           
        };
    }

    componentDidMount() {


    }

    render() {
        return (
            <div className="shunt">
            {
                this.props.combineOrder == 0 || this.props.combineOrder == undefined ?
                    <div className="cardBox">
                        <div>0</div>
                        <div>当前待组合分流订单</div>
                        <div className="blue" onClick={()=>Toast.info('暂无数据')}>组合发单</div>
                    </div>
                : <div className="cardBox">
                    <div> {this.props.combineOrder} </div>
                    <div>当前待组合分流订单</div>
                    <div className="blue" onClick={()=> this.props.goPage("combinationBill")}>组合发单</div>
                </div>
                }
            {
                this.props.pickOrder == 0 ||  this.props.pickOrder == undefined ?
                    <div className="cardBox">
                        <div>0</div>
                        <div>当前待派单分流订单</div>
                        <div className="orange" onClick={()=>Toast.info('暂无数据')}>派单调度</div>
                    </div>
                :<div className="cardBox">
                    <div>{this.props.pickOrder}</div>
                    <div>当前待派单分流订单</div>
                    <div className="orange" onClick={()=> this.props.goPage("Dispatch")}>派单调度</div>
                </div>
            }   
                    <div className="cardBox">
                        <div className="greenOrder">&nbsp;</div>
                        <div>根据需求下分流订单</div>
                        <div className="green" onClick={()=> this.props.goPage("shuntOrder",{shuntType:2})}>分流下单</div>
                    </div>
                    <div className="cardBox">
                        <div className="greenOrder">&nbsp;</div>
                        <div>分流订单记录</div>
                        <div className="gray" onClick={()=> this.props.goPage("ShuntList")}>查看订单</div>
                    </div>
            </div>
            
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Shunt/index.js